import { getIsMockApplicantId } from '../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import { ApplicantProfileDocumentsFolder } from './ApplicantProfileDocumentsFolder'
import { ApplicantProfileDocumentsMockTable } from './ApplicantProfileDocumentsMockTable'

function RentalPortalApplicantProfileDocuments() {
  const { applicantData } = useApplicantProfileContext()

  return getIsMockApplicantId(applicantData?.id) ? (
    <ApplicantProfileDocumentsMockTable />
  ) : (
    <ApplicantProfileDocumentsFolder />
  )
}

export default RentalPortalApplicantProfileDocuments
